import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Link } from "react-router-dom";
import { toPersianNum, toSeperatedNum } from "../../assets/utils";
import "react-slideshow-image/dist/styles.css";
import { selectUserInfo } from "../../redux/user/user.selectors";
import {
  ScoresStyled,
  BalanceWallet,
  BalanceWalletToman,
  BalanceWalletText,
  Tooman,
  AmountBalance,
  Icon,
} from "./userInfoMobile.styles";
import ImageSlider from "../imageSlider/imageSlider.component";
const UserInfoMobile = ({ selectUserInfo }) => {
  console.log(selectUserInfo);
  const { account_balance, point_balance } = selectUserInfo;
  return (
    <div>
      <Link to="/app2/jeton">
        <ScoresStyled className="d-flex align-items-center justify-content-between">
          <div>جمع امتیازات: </div>
          <div>
            {point_balance
              ? toSeperatedNum(toPersianNum(point_balance))
              : "..."}
          </div>
        </ScoresStyled>
      </Link>
      <BalanceWallet onClick={() => (window.location.href = "/app2/wallet")}>
        <BalanceWalletText>
          <Icon></Icon>
          کیف پول
        </BalanceWalletText>
        <BalanceWalletToman>
          <AmountBalance>
            {account_balance
              ? toSeperatedNum(toPersianNum(account_balance))
              : "..."}
            <div className="mr-1">{account_balance > 0 ? "+" : "-"}</div>
          </AmountBalance>
          <Tooman>تومان</Tooman>
        </BalanceWalletToman>
      </BalanceWallet>
      {/* <ImageSlider /> */}
    </div>
  );
};
const mapStateToProps = createStructuredSelector({
  selectUserInfo: selectUserInfo,
});
export default connect(mapStateToProps)(UserInfoMobile);
